import React, { useEffect, useId, useRef } from 'react';
import { cn } from '@/lib/utils';

interface SelectCheckboxProps {
    checked: boolean;
    onChange: () => void;
    indeterminate?: boolean;
    stopPropagation?: boolean;
    ariaLabel?: string;
    className?: string;
}

const SelectCheckbox: React.FC<SelectCheckboxProps> = ({
    checked,
    onChange,
    indeterminate = false,
    stopPropagation = false,
    ariaLabel = 'Selecionar',
    className = '',
}) => {
    const ref = useRef<HTMLInputElement>(null);
    const checkboxId = useId();

    useEffect(() => {
        if (ref.current) {
            ref.current.indeterminate = indeterminate;
        }
    }, [indeterminate]);

    return (
        <label className={cn('checkbox-wrap', className)}>
            <input
                ref={ref}
                id={checkboxId}
                name={checkboxId}
                type="checkbox"
                checked={checked}
                onChange={onChange}
                onClick={stopPropagation ? (e) => e.stopPropagation() : undefined}
                className="checkbox-input"
                aria-label={ariaLabel}
            />
            <div className="checkbox-box w-4 h-4" aria-hidden="true" />
        </label>
    );
};

export default SelectCheckbox;
